"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestMyIDUser = exports.PartialMyIDUserDec = exports.PartialMyIDUser = exports.Role = exports.FunctionalAbility = void 0;
const D = __importStar(require("io-ts/lib/Decoder"));
class FunctionalAbility {
}
exports.FunctionalAbility = FunctionalAbility;
class Role {
}
exports.Role = Role;
const RoleDec = D.struct({
    name: D.string,
    functionalAbilities: D.array(D.struct({
        name: D.string,
    })),
});
class PartialMyIDUser {
}
exports.PartialMyIDUser = PartialMyIDUser;
exports.PartialMyIDUserDec = D.struct({
    'relationship.employeeId': D.string,
    given_name: D.string,
    family_name: D.string,
    roles: D.array(RoleDec),
});
exports.TestMyIDUser = {
    'relationship.employeeId': 'TANEI001',
    given_name: 'Ivan',
    family_name: 'Tanev',
    roles: [
        {
            name: 'Tagger',
            functionalAbilities: [{ name: 'READ' }, { name: 'WRITE' }],
        },
    ],
};
//# sourceMappingURL=partial-myid-user.dto.js.map